import { clearSensorGroups, getSensorGroups, getSensorGroupsRejected, getSensorGroupsResolved, } from '@innovyze/stylovyze/lib/actions/sensorGroups.actions';
import { createReducer } from '@reduxjs/toolkit';
import { STATUS_ENUM } from '@innovyze/stylovyze/lib/types/reducers.types';
export const initialState = {
    sensorGroups: {
        status: STATUS_ENUM.IDLE,
        sensorGroups: [],
        pagination: undefined,
    },
};
const reducer = {
    [clearSensorGroups.toString()]: () => initialState,
    [getSensorGroups.toString()]: state => ({
        ...state,
        sensorGroups: {
            ...state.sensorGroups,
            status: STATUS_ENUM.PENDING,
        },
    }),
    [getSensorGroupsResolved.toString()]: (state, params) => {
        return {
            ...state,
            sensorGroups: {
                status: STATUS_ENUM.SUCCESS,
                sensorGroups: params.payload.sensorGroups,
                pagination: params.payload.pagination,
            },
        };
    },
    [getSensorGroupsRejected.toString()]: state => ({
        ...state,
        sensorGroups: {
            sensorGroups: state.sensorGroups.sensorGroups || [],
            status: STATUS_ENUM.ERROR,
        },
    }),
};
export default createReducer(initialState, reducer);
